'use client';

import { Suspense } from 'react';
import Link from 'next/link';
import { useAuth } from '../../lib/hooks/useAuth';
import { ROUTES } from '../../lib/constants';
import { AuthBackground } from '../../components/auth/AuthBackground';
import { AuthHeader } from '../../components/auth/AuthHeader';
import { AuthForm } from '../../components/auth/AuthForm';
import { AuthModeSwitch } from '../../components/auth/AuthModeSwitch';

function LoginForm() {
  const { loading, form, setField, handleSubmit } = useAuth('login');

  return (
    <div className="flex h-full items-center justify-center px-4" style={{ backgroundColor: 'var(--color-bg)' }}>
      <AuthBackground />
      <div className="relative w-full max-w-md">
        <AuthHeader mode="login" />
        <AuthForm mode="login" loading={loading} form={form} setField={setField} onSubmit={handleSubmit} />
        <p className="text-right text-xs mt-3">
          <Link href={ROUTES.forgotPassword} className="text-[#0b57d0] hover:underline">
            Forgot password?
          </Link>
        </p>
        <AuthModeSwitch mode="login" />
      </div>
    </div>
  );
}

export default function LoginPage() {
  return (
    <Suspense>
      <LoginForm />
    </Suspense>
  );
}
